import { UseAxiosOptions, useAxios } from '@vueuse/integrations/useAxios';
import { AxiosRequestConfig } from 'axios';

export function useFetch<T>(url: string, config: AxiosRequestConfig<T> & UseAxiosOptions<T> = { immediate: true }) {
   return useAxios<T>(url, { ...config }, http, config);
}
